<button class="link-like" (click)="download()" [disabled]="isLoading">
  <span *ngIf="!isLoading">Baixar declaração de conteúdo</span>
  <span *ngIf="isLoading">Gerando...</span>
</button>
